import React from "react";
import classes from "./Comment.module.css";
import he from "he";
import numeral from "numeral";
import { formatPublishedDate } from "../../utility";

export default function Comment(props) {
  let style = { width: "40px", height: "40px" };
  if (props.isReply) {
    style.width = "24px";
    style.height = "24px";
  }
  return (
    <div className={classes.Comment}>
      <div style={style}>
        <img src={props.imgSrc} alt="profile pic" />
      </div>
      <div>
        <h5>{props.name}</h5> <span>{formatPublishedDate(props.date)}</span>
        <div className={classes.Content}>
          <pre>{he.decode(props.content)}</pre>
        </div>
        <div className={classes.Btns}>
          <span>
            <i className="fas fa-thumbs-up" />{" "}
            <span>{numeral(props.likes).format("0.a")}</span>
          </span>
          <i className="fas fa-thumbs-down" />
          <button>REPLY</button>
        </div>
      </div>
    </div>
  );
}
